"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaneAnswerIcons = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const getAllQuestions_1 = __importDefault(require("@opsbase/lib-form/helpers/getAllQuestions"));
const getPercentCompletion_1 = __importDefault(require("@opsbase/lib-form/helpers/getPercentCompletion"));
const isValidAnswer_1 = __importDefault(require("@opsbase/lib-form/helpers/isValidAnswer"));
const Flag_1 = require("@opsbase/lib-issue/Flag");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerformActions"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const AnswerFailIcon_1 = __importDefault(require("./AnswerFailIcon"));
const AnswerStateIcon_1 = __importDefault(require("./AnswerStateIcon"));
const PlainAnswerIcons = ({ color = undefined, scoreText, scoreColor, percentCompletion, }) => {
    const { answer, question, rule } = (0, usePerformQuestion_1.default)();
    const answerColor = (0, react_1.useMemo)(() => percentCompletion === 100 || (0, isValidAnswer_1.default)(answer, question, rule)
        ? (answer === null || answer === void 0 ? void 0 : answer.flag)
            ? (0, Flag_1.flagColor)(answer === null || answer === void 0 ? void 0 : answer.flag)
            : lib_palette_1.default.positive
        : scoreColor || color || lib_palette_1.default.Platinum, [answer, color, percentCompletion, question, rule, scoreColor]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true, centered: true },
        scoreText ? react_1.default.createElement(Text_1.default, { color: answerColor }, scoreText) : null,
        react_1.default.createElement(AnswerFailIcon_1.default, null),
        react_1.default.createElement(AnswerStateIcon_1.default, { color: color, percentCompletion: percentCompletion }))), [scoreText, answerColor, color, percentCompletion]);
};
const SectionAnswerIcons = (props) => {
    const { form } = (0, usePerform_1.default)();
    const { question, answer } = (0, usePerformQuestion_1.default)();
    const { addListener, removeListener } = (0, usePerformActions_1.default)();
    const { forceUpdate, tick, acknowledgeUpdate } = (0, useForceUpdate_1.default)();
    const currListener = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        const childQuestionIds = (0, getAllQuestions_1.default)(question).map(z => z.nodeId);
        if (currListener.current)
            removeListener('answered', currListener.current);
        currListener.current = event => {
            if (childQuestionIds.includes(event.nodeId))
                forceUpdate();
        };
        addListener('answered', currListener.current);
        return () => {
            if (currListener.current)
                removeListener('answered', currListener.current);
        };
    }, [addListener, forceUpdate, question, removeListener]);
    const pctCompletion = (0, react_1.useMemo)(() => {
        if (answer.notApplicable)
            return 100;
        acknowledgeUpdate(tick);
        return (0, getPercentCompletion_1.default)(form, question);
    }, [acknowledgeUpdate, answer.notApplicable, form, question, tick]);
    return react_1.default.createElement(PlainAnswerIcons, Object.assign({}, props, { percentCompletion: pctCompletion }));
};
const PaneAnswerIcons = (props) => {
    const { question } = (0, usePerformQuestion_1.default)();
    if (question.type === FormQuestionType_1.default.SECTION || question.type === FormQuestionType_1.default.REPETITION)
        return react_1.default.createElement(SectionAnswerIcons, Object.assign({}, props));
    return react_1.default.createElement(PlainAnswerIcons, Object.assign({}, props));
};
exports.PaneAnswerIcons = PaneAnswerIcons;
exports.default = exports.PaneAnswerIcons;
